/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React from 'react';

 const ChartIcon = ({ className, style }) => {
  return (
    <svg 
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      id="svg" 
      version="1.1"
      width="400" 
      height="400" 
      viewBox="0, 0, 400, 400">
        <g id="svgg">
          <path
            id="path0"
            d="M58.277 34.079 L 57.415 34.426 57.511 158.552 L 57.608 282.679 80.383 282.679 L 103.158 282.679 103.254 158.784 C 103.341 46.529,103.294 34.832,102.748 34.286 C 102.060 33.598,59.963 33.401,58.277 34.079 M297.977 163.920 C 297.876 164.185,297.838 191.014,297.892 223.541 L 297.990 282.679 320.671 282.778 L 343.352 282.877 343.255 223.257 L 343.158 163.636 320.659 163.538 C 302.863 163.459,298.122 163.540,297.977 163.920 " 
            stroke="none"
            fill="#0c4cb4" 
            fillRule="evenodd"/>
          <path 
            id="path1" 
            d="M56.727 33.378 C 55.810 34.295,56.090 283.131,57.008 283.623 C 58.586 284.467,103.259 284.138,103.719 283.279 C 104.273 282.243,104.273 34.695,103.719 33.659 C 103.229 32.744,57.634 32.471,56.727 33.378 M102.748 34.286 C 103.294 34.832,103.341 46.529,103.254 158.784 L 103.158 282.679 80.383 282.679 L 57.608 282.679 57.511 158.552 L 57.415 34.426 58.277 34.079 C 59.963 33.401,102.060 33.598,102.748 34.286 M140.654 34.163 C 140.554 34.426,140.516 46.785,140.571 61.627 L 140.670 88.612 163.254 88.712 C 184.145 88.805,185.873 88.763,186.316 88.161 C 187.114 87.074,187.001 35.681,186.198 34.535 L 185.603 33.684 163.220 33.684 C 145.666 33.684,140.798 33.787,140.654 34.163 M214.609 89.442 C 214.111 89.940,214.312 162.102,214.813 162.603 C 215.419 163.209,258.419 163.269,259.547 162.666 C 260.463 162.175,260.739 90.557,259.828 89.646 C 259.327 89.146,215.105 88.946,214.609 89.442 M297.416 162.679 C 296.265 163.831,296.201 282.345,297.351 283.386 C 298.549 284.470,343.027 284.341,344.118 283.250 C 344.883 282.485,344.887 282.129,344.788 222.929 L 344.689 163.377 343.785 162.646 C 342.342 161.477,298.587 161.509,297.416 162.679 M343.255 223.257 L 343.352 282.877 320.671 282.778 L 297.990 282.679 297.892 223.541 C 297.838 191.014,297.876 164.185,297.977 163.920 C 298.122 163.540,302.863 163.459,320.659 163.538 L 343.158 163.636 343.255 223.257 M29.933 311.656 C 29.223 312.365,29.280 337.736,29.993 338.328 C 30.891 339.073,370.828 338.737,371.300 337.990 C 371.867 337.094,371.787 312.227,371.215 311.656 C 370.546 310.986,30.603 310.986,29.933 311.656 "
            stroke="none"
            fill="#ccdcec"
            fillRule="evenodd"/>
        </g>
    </svg>
  )
};

export default ChartIcon;
